import React, { useContext, useEffect, useRef, useState } from 'react';
import HeaderLanding from '../../layouts/Header/HeaderLanding'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { StateController } from './../../App';
import { Navigation, Pagination } from 'swiper/modules';
import Preloader from '../atoms/Preloader';
import { sendDataLayer } from '../../utils/functions';
import { Link } from 'react-router-dom';

const Onboarding = ({ isLogin }) => {
    const { context } = useContext(StateController);
    const [slides, setSlides] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(false);
    const titleRefs = useRef([]);

    useEffect(() => {
        if (window.location.pathname.includes("onboarding")) {
            document.body.classList.add("onboardin-page");
        } else {
            document.body.classList.remove("onboarding-page");
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 998);
        };
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const loadSlides = () => {
            setTimeout(() => {
                const slidesSegment1 = [
                    {
                        num: "1",
                        text: "<b>Descubre tu objetivo de facturación y las categorías </b>  que te llevarán a ganar premios increíbles.",
                        image: "/assets/images/sli1_1.png",
                        imageMobile: "/assets/images/sli1_A_M.png"
                    },
                    {
                        num: "2",
                        text: "<b>Usa tu Tarjeta Mastercard Débito en todas tus compras</b> para alcanzar las objetivos.",
                        image: "/assets/images/sli2_2.png",
                        imageMobile: "/assets/images/sli2_A_M.png"
                    },
                    {
                        num: "3",
                        text: "<b>Canjea la e-Gift Card que más te guste.</b> Sigue consumiendo y participa para ganar el premio mayor.",
                        image: "/assets/images/sli3_1.png",
                        imageMobile: "/assets/images/sli3_A_M.png"
                    },
                    {
                        num: "4",
                        // title: "¡Gana un viaje a Río de Janeiro para dos!",
                        text: "<b>Gana un viaje para dos personas.</b> Cada vez que cumplas tu objetivo estarás más cerca de ganar el premio mayor.",
                        image: "/assets/images/sli4_1.png",
                        imageMobile: "/assets/images/Sli4_A_M.png",
                        tyc: "*Aplican términos y condiciones.",
                        link: "/GanaConMastercardDebit/terminos-y-condiciones"
                    }
                ];

                const slidesSegment2 = [
                    {
                        num: "1",
                        text: "<b>Las compras que haces</b> con tu Tarjeta de Débito Mastercard te premian.",
                        image: "/assets/images/sli2_2.png",
                        imageMobile: "/assets/images/sli1_I_M.png"
                    },
                    {
                        num: "2",
                        text: "<b>Conoce tu objetivo y realiza todas las compras</b> con tu Tarjeta de Débito Mastercard para alcanzarla.",
                        image: "/assets/images/sli2_1.png",
                        imageMobile: "/assets/images/sli2_I_M.png"
                    },
                    {
                        num: "3",
                        text: "<b>¡Elige tu e-Gift Card favorita y canjéala</b> en las tiendas disponibles!",
                        image: "/assets/images/sli3_2.png",
                        imageMobile: "/assets/images/sli3_I_M.png"
                    },
                    {
                        num: "4",
                        // title: "¡Un kit de Apple podría ser tuyo!",
                        text: "<b>Gana un viaje para dos personas.</b> Cada vez que cumplas tu objetivo estarás más cerca de ganar el premio mayor.",
                        image: "/assets/images/sli4_1.png",
                        imageMobile: "/assets/images/sli4_I_M.png",
                        tyc: "*Aplican términos y condiciones.",
                        link: "/GanaConMastercardDebit/terminos-y-condiciones"
                    }
                ];

                setSlides(context.user.segment === '1' ? slidesSegment1 : slidesSegment2);
                setLoading(false);
            }, 1500);
        };

        if (context && context.user) {
            loadSlides();
        } else {
            setLoading(false);
        }
    }, [context]);

    useEffect(() => {
        if (titleRefs.current.length === 0) {
            titleRefs.current = new Array(slides.length).fill(null);
        }
    }, [slides]);

    if (loading) {
        return <div>
            <Preloader
                type="section"
                invert
            />
        </div>;
    }

    const layerOnboarding = () => {

    }

    const handleSlideChange = (swiper) => {
        const activeTitle = titleRefs.current[activeIndex]?.innerText;
        console.log('Active slide title:', activeTitle);
        setActiveIndex(swiper.activeIndex);
        sendDataLayer({ datalayer: ({ event: "onboarding", text: activeTitle, }), repeat: true })
    };

    const handleRedirectToProgreso = () => {
        const activeTitle = titleRefs.current[activeIndex]?.innerText;
        console.log('Active slide title:', activeTitle);
        sendDataLayer({ datalayer: ({ event: "onboarding", text: activeTitle, }), repeat: true })
        window.location.href = '/GanaConMastercardDebit/progreso';
    };

    const tycOnboarding = () => {
        sendDataLayer({ datalayer: ({ event: "tyc_onboarding"}), repeat: true })
    }

    const omitirOnboarding = () => {
        console.log('omitirOnboarding')
        sendDataLayer({ datalayer: ({ event: "cancel_onboarding"}), repeat: true })
    }



    return (
        <>

            {
                context ?
                    <div className='mc-page onboarding'>
                        {!isLogin && <HeaderLanding />}
                        <Swiper
                            modules={[Navigation, Pagination]}
                            navigation={{
                                nextEl: '.swiper-button-next-custom',
                                prevEl: '.swiper-button-prev-custom'
                            }}
                            pagination={{ clickable: true }}
                            spaceBetween={50}
                            slidesPerView={1}
                            onSlideChange={handleSlideChange}
                        >
                            {slides.map((slide, index) => (
                                <SwiperSlide key={index}>
                                    <div className={ activeIndex <= 2 ? 'slide-content' : 'slide-content sin-omitir'}>
                                        <div className="text">
                                            <div className='num-container'>
                                                <span>{slide.num}</span>
                                            </div>
                                            <div>
                                                <h3>{slide.title}</h3>
                                                <p
                                                    ref={(el) => (titleRefs.current[index] = el)}
                                                    data={slide.text}
                                                    dangerouslySetInnerHTML={{ __html: slide.text }}
                                                ></p>

                                            </div>
                                            <div className='tyc-container'>
                                                <a rel="noreferrer" target="_blank" onClick={tycOnboarding} href={slide.link}>{slide.tyc}</a>
                                            </div>
                                        </div>
                                        <div className="image">
                                            <img src={isMobile ? slide.imageMobile : slide.image} alt={`Slide ${index + 1}`} />
                                        </div>
                                    </div>
                                    <div className='omitir-container'><a href="/GanaConMastercardDebit/progreso" onClick={omitirOnboarding}> { activeIndex <= 2 && 'Omitir'}</a></div>


                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <div className={activeIndex > 0 ? 'swiper-button-prev swiper-button-prev-custom active' : 'swiper-button-prev swiper-button-prev-custom'}></div>
                        {activeIndex === slides.length - 1 ? (
                            <div className='btn-start-progress'>
                                <Link to="/GanaConMastercardDebit/progreso" onClick={() => { handleRedirectToProgreso(); layerOnboarding() }}>Quiero empezar</Link>
                            </div>
                        ) : (
                            <div className="swiper-button-next swiper-button-next-custom" onClick={() => {
                                layerOnboarding();
                            }}>
                                {context?.user?.segment === '2'
                                    ? activeIndex === 0
                                        ? 'Descubre cómo ganar'
                                        : 'Siguiente'
                                    : activeIndex === 3
                                        ? 'Quiero empezar'
                                        : 'Siguiente'
                                }
                            </div>
                        )}
                    </div >
                    :
                    <Preloader
                        type="fullscreen"
                        invert
                    />
            }
        </>
    );
};

export default Onboarding;
